import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import useEvent from '@src/hooks/useEvent';

const EventNameWrapper = styled.div`
	padding-bottom: 16px;
	border-bottom: 1px solid #F0F0F0;

	@media ${props => props.theme.device.lgDesktop} {
		padding-bottom: 12px;
	}

	@media ${props => props.theme.device.desktop} {
		padding-bottom: 12px;
	}
`;

const Tags = styled.div`
	display: flex;
`;

const Tag = styled.div`
	padding: 4px 8px;
	border-radius: 4px;
	border: 1px solid #DDDDDD;
	font-size: 12px;
	color: #101010;

	&:not(:first-child) {
		margin-left: 8px;
	}
`;

const Name = styled.div`
	margin-top: 8px;
	display: -webkit-box;
	text-overflow: ellipsis;
	overflow: hidden;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	font-size: 24px;
	font-weight: 500;
	color: #101010;

	@media ${props => props.theme.device.mobile} {
		font-size: 22px;
	}
`;

const Highlight = styled.pre`
	margin: 16px 0 0;
	display: -webkit-box;
	text-overflow: ellipsis;
	overflow: hidden;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	white-space: pre-wrap;
	word-break: break-word;
	font-family: 'Roboto', 'Noto Sans TC', '微軟正黑體', sans-serif;
	color: #676767;

	@media ${props => props.theme.device.lgDesktop} {
		margin: 12px 0 0;
		font-size: 14px;
	}

	@media ${props => props.theme.device.desktop} {
		margin: 12px 0 0;
		font-size: 14px;
	}
`;

interface IEventName {
	className?: string;
}

const EventName = ({ className }: IEventName): JSX.Element => {
	const { t } = useTranslation();
	const { event } = useEvent();

	return (
		<EventNameWrapper className={className}>
			<Tags>
				{!event['public'] && <Tag>{t('common:private')}</Tag>}
				<Tag>{t('event:event')}</Tag>
			</Tags>
			<Name>{event.name}</Name>
			<Highlight>{event.highlight}</Highlight>
		</EventNameWrapper>
	);
};

export default EventName;
